import React from 'react';

const ShopHeader = ({
  viewMode,
  setViewMode,
  filteredProducts,
  products,
  activeCollectionFilter,
  itemsPerPage,
  setItemsPerPage,
  sortBy,
  setSortBy,
  currentPage,
  totalPages
}) => {
  // Calculate showing range for pagination
  const getShowingRange = () => {
    if (filteredProducts.length === 0) return { start: 0, end: 0 };

    const start = (currentPage - 1) * itemsPerPage + 1;
    const end = Math.min(currentPage * itemsPerPage, filteredProducts.length);

    return { start, end };
  };

  const { start, end } = getShowingRange();

  return (
    <div className="shop-wrap">
      <div className="shop-header">
        <h4 className="title">Boutique</h4>
      </div>
      <div className="shop-page-meta mb-30">
        {/* <div className="shop-grid-menu">
          <ul>
            <li className={viewMode === 'grid' ? 'active' : ''}>
              <a href="#" onClick={(e) => { e.preventDefault(); setViewMode('grid'); }}>
                <i className="fas fa-th" />
              </a>
            </li>
            <li className={viewMode === 'list' ? 'active' : ''}>
              <a href="#" onClick={(e) => { e.preventDefault(); setViewMode('list'); }}>
                <i className="fas fa-list" />
              </a>
            </li>
          </ul>
        </div> */}
        <div className="shop-showing-result">
          <p>
            Affichage de {start}-{end} sur {filteredProducts.length} articles
            {activeCollectionFilter.length > 0 && ` dans ${activeCollectionFilter.length} collection(s)`}
          </p>
        </div>
        <div className="shop-show-list shop-short-by">
          <form>
            <label htmlFor="show">Afficher</label>
            <select
              id="show"
              className="selected"
              value={itemsPerPage}
              onChange={(e) => setItemsPerPage(parseInt(e.target.value))}
            >
              <option value="9">09</option>
              <option value="15">15</option>
              <option value="21">21</option>
            </select>
          </form>
        </div>
        <div className="shop-short-by">
          <form>
            <label htmlFor="shortBy">Trier par</label>
            <select
              id="shortBy"
              className="selected"
              value={sortBy}
              onChange={(e) => setSortBy(e.target.value)}
            >
              <option value="Sort by latest">Trier par nouveauté</option>
              <option value="Low to high">Prix croissant</option>
              <option value="High to low">Prix décroissant</option>
              <option value="Popularity">Popularité</option>
            </select>
          </form>
        </div>
      </div>
    </div>
  );
};

export default ShopHeader;